import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import "./styles/main.scss";

import Header from "./components/Header";
import Fold from "./components/Fold";
import Content from "./components/Content";

import Header2 from "./components/rozi-and-moni/Header";
import Fold2 from "./components/rozi-and-moni/Fold";
import Content2 from "./components/rozi-and-moni/Content";

import Header3 from "./components/desi-and-viktor/Header";
import Fold3 from "./components/desi-and-viktor/Fold";
import Content3 from "./components/desi-and-viktor/Content";

import Header4 from "./components/lyubomira-and-aleksandur/Header";
import Fold4 from "./components/lyubomira-and-aleksandur/Fold";
import Content4 from "./components/lyubomira-and-aleksandur/Content";
import MetaData from "./components/MetaData";
import { HelmetProvider } from "react-helmet-async";

import Header5 from "./components/abiturient-lyuboslav/Header";
import Fold5 from "./components/abiturient-lyuboslav/Fold";
import Content5 from "./components/abiturient-lyuboslav/Content";

import Fold6 from "./components/maria-and-krasimir/Fold";
import Content6 from "./components/maria-and-krasimir/Content";

import Fold7 from "./components/inna-and-stoyan/Fold";
import Content7 from "./components/inna-and-stoyan/Content";

import Fold8 from "./components/katerina-and-ilian/Fold";
import Content8 from "./components/katerina-and-ilian/Content";
import { translations } from "./components/katerina-and-ilian/translations";


import Fold9 from "./components/nelly-and-angel/Fold";
import Content9 from "./components/nelly-and-angel/Content";
import logoImage from "./components/nelly-and-angel/images/logo-n-a.webp";
import { translations as nellyAndAngelTranslations } from "./components/nelly-and-angel/translations";

// NB: Don't forget to add the meta data in the server.js file

function App() {
  return (
    <HelmetProvider>
      <div className="MyWedding">
        <Router>
          <Routes>
            {/* Add your routes here */}
            <Route path="/" element={<GiziAndDido />} />
            <Route path="/gizi-and-dido" element={<GiziAndDido />} />
            <Route path="/rozi-and-moni" element={<RoziAndMoni />} />
            <Route path="/desi-and-viktor" element={<DesiAndViktor />} />
            <Route path="/lia-and-sasho" element={<LyubomiraAndAleksandur />} />
            <Route path="/lyubomira-and-aleksandur" element={<LyubomiraAndAleksandur />} />
            {/* <Route path="/maria-and-krasimir" element={
              <div className="flex flex-align-center" style={{ backgroundColor: "#9E9E9E", width: "100%", height: "100vh" }}>
                <MetaData 
                  title="Сватбена покана | Мария и Красимир"
                  description="Сватбената покана на Мария и Красимир"
                  ogUrl="https://svatbena-pokana.com/maria-and-krasimir"
                  ogImage="https://svatbena-pokana.com/maria-and-krasimir.jpg"
                  siteName="Сватбена покана | Мария и Красимир"
                />
                <img src={ComingSoon} alt="Maria and Krasimir" style={{width: "100%", minWidth: "100%", height: "auto", border: "4px solid white", boxShadow: "0 4px 6px rgba(0, 0, 0, 0.3), 0 1px 3px rgba(0, 0, 0, 0.2), 4px 4px 0px rgba(255, 255, 255, 0.2)"}}/>
              </div>
            } /> */}
            <Route path="/maria-and-krasimir" element={<MariaAndKrasimir />} />
            <Route path="/inna-and-stoyan" element={<InnaAndStoyan />} />
            <Route path="/katerina-and-ilian" element={<KaterinaAndIlian />} />
            <Route path="/katerina-and-ilian-en" element={<KaterinaAndIlianEn />} />
            <Route path="/buzik-samo-za-bal-na-lyubo-e" element={<AbiturientLyuboslav />} />
            <Route path="/nelly-and-angel" element={<NellyAndAngel />} />
            <Route path="/nelly-and-angel-en" element={<NellyAndAngelEn />} />
          </Routes>
        </Router>
      </div>
    </HelmetProvider>
  );
}

// GiziAndDido component for the "/gizi-and-dido" path
function GiziAndDido() {
    // Use useEffect to update CSS variables when the component mounts
    useEffect(() => {
      applyFontVariables(FONTS_VARIABLES_DEFAULT);
    }, []);
  return (
    <div id="gizi-and-dido">
      <MetaData 
        title="Сватбена покана | Гизи и Дидо"
        description="Сватбената покана на Гизи и Дидо"
        ogUrl="https://svatbena-pokana.com/gizi-and-dido"
        ogImage="https://svatbena-pokana.com/dido-and-gizi-wedding2.jpg"
        siteName="Сватбена покана | Гизи и Дидо"
      />
      <div className="bg-fold">
        <Header />
        <Fold />
      </div>
      <Content />
    </div>
  );
}

function RoziAndMoni() {
  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyFontVariables(FONTS_VARIABLES_DEFAULT);
    applyColorVariables(COLOR_VARIABLES_ROZI_AND_MONI);
  }, []);

  return (
    <div id="rozi-and-moni">
      <MetaData 
        title="Сватбена покана | Рози и Мони"
        description="Сватбената покана на Рози и Мони"
        ogUrl="https://svatbena-pokana.com/rozi-and-moni"
        siteName="Сватбена покана | Рози и Мони"
      />
      <div className="bg-fold-gradient">
        <Header2 />
        <Fold2 />
      </div>
      <Content2 />
    </div>
  );
}

const COLOR_VARIABLES_ROZI_AND_MONI = {
  "--border-color": "#AABFA6",
  "--primary-color": "#5375a3",
  "--secondary-color": "#C8AAAF",
  "--third-color": "#587555",
  "--hover-color": "#A7B8CE",
  "--link-color": "#5375a3",
  "--text-color": "#384347"
};

function DesiAndViktor() {
  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyFontVariables(FONTS_VARIABLES_DEFAULT);
    applyColorVariables(COLOR_VARIABLES_DESI_AND_VIKTOR);
  }, []);

  return (
    <div id="desi-and-viktor">
      <MetaData 
        title="Сватбена покана | Деси и Виктор"
        description="Сватбената покана на Деси и Виктор"
        ogUrl="https://svatbena-pokana.com/desi-and-viktor"
        siteName="Сватбена покана | Деси и Виктор"
      />
      <div className="bg-fold">
        <Header3 />
        <Fold3 />
      </div>
      <Content3 />
    </div>
  );
}

const COLOR_VARIABLES_DESI_AND_VIKTOR = {
  "--border-color": "#38807Fff",
  "--primary-color": "#38807Fff",
  "--secondary-color": "#C8E2F1ff",
  "--third-color": "#F1D6D6",
  "--hover-color": "#A7B8CE",
  "--link-color": "#38807Fff",
};

function LyubomiraAndAleksandur() {
  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyFontVariables(FONTS_VARIABLES_DEFAULT);
    applyColorVariables(COLOR_VARIABLES_LYUBOMIRA_AND_ALEKSANDUR);
  }, []);

  return (
    <div id="lyubomira-and-aleksandur">
      <MetaData 
        title="Сватбена покана | Лия и Сашо"
        description="Сватбената покана на Лия и Сашо"
        ogUrl="https://svatbena-pokana.com/lia-and-sasho"
        siteName="Сватбена покана | Лия и Сашо"
      />
      <div className="bg-fold">
        <Header4 />
        <Fold4 />
      </div>
      <Content4 />
    </div>
  );
}

const COLOR_VARIABLES_LYUBOMIRA_AND_ALEKSANDUR = {
  "--border-color": "#A1C5E8",
  "--primary-color": "#A1C5E8",
  "--secondary-color": "#E1D4E9",
  "--third-color": "#BFB8DB",
  "--hover-color": "#fca9bc",
  "--link-color": "#fca9bc",
};


function AbiturientLyuboslav() {
  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyFontVariables(FONTS_VARIABLES_DEFAULT);
    applyColorVariables(COLOR_VARIABLES_ABITURIENT_LYUBOSLAV);
  }, []);

  return (
    <div id="abiturient-lyuboslav">
      <MetaData 
        title="Абитуриентски бал | Любослав"
        description="Покана за абитуриентския бал на Любослав"
        ogUrl="https://svatbena-pokana.com/buzik-samo-za-bal-na-lyubo-e"
        ogImage="https://svatbena-pokana.com/abiturient-lyuboslav.jpg"
        siteName="Абитуриентски бал | Любослав"
      />
      <div className="bg-white">
        <Header5 />
        <Fold5 />
      </div>
      <Content5 />
    </div>
  );
}

const COLOR_VARIABLES_ABITURIENT_LYUBOSLAV = {
  "--border-color": "#38807Fff",
  "--primary-color": "#000000",
  "--secondary-color": "#7BAAC1",
  "--third-color": "#e3e9f5",
  "--hover-color": "#A7B8CE",
  "--link-color": "#38807Fff",
};

function MariaAndKrasimir() {
  const [loading, setLoading] = useState(true);

  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyColorVariables(COLOR_VARIABLES_MARIA_AND_KRASIMIR);
    applyFontVariables(FONTS_VARIABLES_MARIA_AND_KRASIMIR);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);


  return (
    <div id="maria-and-krasimir" className={"relative"}>
      {loading && (
        <div className="loading-container">
          <div className="flex full-height full-width flex-justify-center flex-align-center">
            <div className="loader"></div>
          </div>
        </div>
      )}

       <MetaData 
          title="Сватбена покана | Мария и Красимир"
          description="Сватбената покана на Мария и Красимир"
          ogUrl="https://svatbena-pokana.com/maria-and-krasimir"
          ogImage="https://svatbena-pokana.com/maria-and-krasimir.jpg"
          siteName="Сватбена покана | Мария и Красимир"
        />
      <div className={`bg-secondary opacity-0 ${!loading && "animation-fade-in animation-duration-2s animation-delay-300ms"}`}>
        <Fold6 />
        <Content6 />
      </div>
      {/* <div className="flex" style={{height: 100}}>
          <div className="col" style={{background: "#38807Fff", height: 100}}>--border-color</div>
          <div className="col" style={{background: "#38807Fff", height: 100}}>primary, link</div>
          <div className="col" style={{background: "#C8E2F1ff", height: 100}}>secondary</div>
          <div className="col" style={{background: "#F1D6D6", height: 100}}>third</div>
          <div className="col" style={{background: "#ede5e4", height: 100}}>base</div>
          <div className="col" style={{background: "#A7B8CE", height: 100}}>hover</div>
          <div className="col" style={{background: "#38807Fff", height: 100}}>link color</div>
      </div> */}
    </div>
  );
}

const COLOR_VARIABLES_MARIA_AND_KRASIMIR = {
  "--border-color": "#38807Fff",
  "--primary-color": "#231f20",
  "--secondary-color": "#f6f6f5",
  "--third-color": "#bababa",
  "--hover-color": "#f6f6f5",
  "--link-color": "#f6f6f5",
  "--base-color": "#f6f6f5",
};  

const FONTS_VARIABLES_MARIA_AND_KRASIMIR = {
  "--heading-family": "Asela, Century Gothic, Montserrat Alternates",
  "--body-family": "Montserrat Alternates, Century Gothic",
};  

function NellyAndAngel() {
  const [loading, setLoading] = useState(true);

  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyColorVariables(COLOR_VARIABLES_NELLY_AND_ANGEL);
    applyFontVariables(FONTS_VARIABLES_NELLY_AND_ANGEL);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);


  return (
    <div id="nelly-and-angel" className={"relative lang-bg"}>
      {loading && (
        <div className="loading-container">
          <div className="flex full-height full-width flex-justify-center flex-align-center">
            <div className="text-center">
              <img src={logoImage} className="logo-image m-auto" width="120px" height="auto" />
              <div className="loader"></div>
            </div>
          </div>
        </div>
      )}

       <MetaData
          title="Сватбена покана | Нели и Ангел"
          description="Сватбената покана на Нели и Ангел"
          ogUrl="https://svatbena-pokana.com/nelly-and-angel"
          ogImage="https://svatbena-pokana.com/nelly-and-angel.jpg"
          siteName="Сватбена покана | Нели и Ангел"
        />
      <div className={`bg-secondary opacity-0 ${!loading && "animation-fade-in animation-duration-2s animation-delay-300ms"}`}>
        <Fold9 t={nellyAndAngelTranslations.bg} />
        <Content9 t={nellyAndAngelTranslations.bg} />
      </div>
    </div>
  );
}

function NellyAndAngelEn() {
  const [loading, setLoading] = useState(true);

  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyColorVariables(COLOR_VARIABLES_NELLY_AND_ANGEL);
    applyFontVariables(FONTS_VARIABLES_NELLY_AND_ANGEL);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);


  return (
    <div id="nelly-and-angel" className={"relative lang-en"}>
      {loading && (
        <div className="loading-container">
          <div className="flex full-height full-width flex-justify-center flex-align-center">
            <div className="text-center">
              <img src={logoImage} className="logo-image m-auto" width="120px" height="auto" />
              <div className="loader"></div>
            </div>
          </div>
        </div>
      )}

       <MetaData
          title="Wedding Invitation | Nelly and Angel"
          description="Wedding invitation of Nelly and Angel"
          ogUrl="https://svatbena-pokana.com/nelly-and-angel-en"
          ogImage="https://svatbena-pokana.com/nelly-and-angel.jpg"
          siteName="Wedding Invitation | Nelly and Angel"
        />
      <div className={`bg-secondary opacity-0 ${!loading && "animation-fade-in animation-duration-2s animation-delay-300ms"}`}>
        <Fold9 t={nellyAndAngelTranslations.en} />
        <Content9 t={nellyAndAngelTranslations.en} />
      </div>
    </div>
  );
}

const COLOR_VARIABLES_NELLY_AND_ANGEL = {
  "--border-color": "#67674f",
  "--primary-color": "#767643",
  "--secondary-color": "#ecdca8",
  "--third-color": "#ebc880",
  "--hover-color": "#ebc880",
  "--link-color": "#f6f6f5",
  "--base-color": "#fbf8ed",
};  

const FONTS_VARIABLES_NELLY_AND_ANGEL = {
  "--heading-family": "Asela, Century Gothic, Montserrat Alternates",
  "--body-family": "Montserrat Alternates, Century Gothic",
};  

function KaterinaAndIlian() {
  const [loading, setLoading] = useState(true);

  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyColorVariables(COLOR_VARIABLES_KATERINA_AND_ILIAN);
    applyFontVariables(FONTS_VARIABLES_KATERINA_AND_ILIAN);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);


  return (
    <div id="katerina-and-ilian" className={"relative"}>
      {loading && (
        <div className="loading-container">
          <div className="flex full-height full-width flex-justify-center flex-align-center">
            <div className="loader"></div>
          </div>
        </div>
      )}

       <MetaData
          title="Сватбена покана | Катерина и Илиан"
          description="Сватбената покана на Катерина и Илиан"
          ogUrl="https://svatbena-pokana.com/katerina-and-ilian"
          ogImage="https://svatbena-pokana.com/katerina-and-ilian.jpg"
          siteName="Сватбена покана | Катерина и Илиан"
        />
      <div className={`bg-white opacity-0 ${!loading && "animation-fade-in animation-delay-300ms animation-duration-2s"}`}>
        <Fold8 t={translations.bg} />
        <Content8 t={translations.bg} />
      </div>
    </div>
  );
}

function KaterinaAndIlianEn() {
  const [loading, setLoading] = useState(true);

  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyColorVariables(COLOR_VARIABLES_KATERINA_AND_ILIAN);
    applyFontVariables(FONTS_VARIABLES_KATERINA_AND_ILIAN);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);


  return (
    <div id="katerina-and-ilian" className={"relative"}>
      {loading && (
        <div className="loading-container">
          <div className="flex full-height full-width flex-justify-center flex-align-center">
            <div className="loader"></div>
          </div>
        </div>
      )}

       <MetaData
          title="Wedding Invitation | Katerina and Ilian"
          description="Wedding invitation of Katerina and Ilian"
          ogUrl="https://svatbena-pokana.com/katerina-and-ilian-en"
          ogImage="https://svatbena-pokana.com/katerina-and-ilian.jpg"
          siteName="Wedding Invitation | Katerina and Ilian"
        />
      <div className={`bg-white opacity-0 ${!loading && "animation-fade-in animation-duration-2s animation-delay-300ms"}`}>
        <Fold8 t={translations.en} />
        <Content8 t={translations.en} />
      </div>
    </div>
  );
}


const COLOR_VARIABLES_KATERINA_AND_ILIAN = {
  "--border-color": "#45291f",
  "--primary-color": "#5d3929",
  "--secondary-color": "#45291f",
  "--third-color": "#d6b989",
  "--hover-color": "#45291f",
  "--link-color": "#5d3929",
  "--base-color": "#ffffff",
};  

const FONTS_VARIABLES_KATERINA_AND_ILIAN = {
  "--heading-family": "Asela, Century Gothic, Montserrat Alternates",
  "--body-family": "Montserrat Alternates, Century Gothic",
};  



function InnaAndStoyan() {
  const [loading, setLoading] = useState(true);

  // Use useEffect to update CSS variables when the component mounts
  useEffect(() => {
    applyColorVariables(COLOR_VARIABLES_INNA_AND_STOYAN);
    applyFontVariables(FONTS_VARIABLES_INNA_AND_STOYAN);

    const timer = setTimeout(() => {
      setLoading(false);
    }, 3000); // 3 seconds

    return () => clearTimeout(timer);
  }, []);


  return (
    <div id="inna-and-stoyan" className={"relative"}>
      {loading && (
        <div className="loading-container">
          <div className="flex full-height full-width flex-justify-center flex-align-center">
            <div className="loader"></div>
          </div>
        </div>
      )}

       <MetaData 
          title="Сватбена покана | Инна и Стоян"
          description="Сватбената покана на Инна и Стоян"
          ogUrl="https://svatbena-pokana.com/inna-and-stoyan"
          ogImage="https://svatbena-pokana.com/inna-and-stoyan.jpg"
          siteName="Сватбена покана | Инна и Стоян"
        />
      <div className={`bg-secondary opacity-0 ${!loading && "animation-fade-in animation-duration-2s animation-delay-300ms"}`}>
        <Fold7 />
        <Content7 />
      </div>
      {/* <div className="flex" style={{height: 100}}>
          <div className="col" style={{background: "#9C6055ff", height: 100}}>--border-color (terracotta-clay)</div>
          <div className="col" style={{background: "#CC978Eff", height: 100}}>primary, link (rosy-taupe)</div>
          <div className="col" style={{background: "#F0ECE3ff", height: 100}}>secondary (soft-linen)</div>
          <div className="col" style={{background: "#EAB1A1ff", height: 100}}>third (powder-blush)</div>
          <div className="col" style={{background: "#ede5e4", height: 100}}>base</div>
          <div className="col" style={{background: "#BEA076ff", height: 100}}>hover (camel)</div>
          <div className="col" style={{background: "#CC978Eff", height: 100}}>link color (rosy-taupe)</div>
      </div> */}
    </div>
  );
}
const COLOR_VARIABLES_INNA_AND_STOYAN = {
  "--border-color": "#9C6055ff", // terracotta-clay
  "--primary-color": "#CC978Eff", // rosy-taupe
  "--secondary-color": "#F0ECE3ff", // soft-linen
  "--third-color": "#EAB1A1ff", // powder-blush
  "--hover-color": "#BEA076ff", // camel
  "--link-color": "#CC978Eff", // rosy-taupe
  "--base-color": "#ede5e4", // kept from original
};  

const FONTS_VARIABLES_INNA_AND_STOYAN = {
  "--heading-family": "Asela, Century Gothic, Montserrat Alternates",
  "--body-family": "Montserrat Alternates, Century Gothic",
};  


const FONTS_VARIABLES_DEFAULT = {
  "--heading-family": "Caveat",
  "--body-family": "Inter",
};  

// Function to apply variables to the document
function applyColorVariables(colorVariables) {
  Object.entries(colorVariables).forEach(([variable, value]) => {
    document.documentElement.style.setProperty(variable, value);
  });
}

// Function to apply variables to the document
function applyFontVariables(fontVariables) {
  Object.entries(fontVariables).forEach(([variable, value]) => {
    document.documentElement.style.setProperty(variable, value);
  });
}

export default App;
